import * as React from 'react';


export default class Diaries extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
        <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="exzeo_revamp_icons" fillRule="evenodd" transform="translate(-108.000000, -65.000000)">
            <g id="Group-9" transform="translate(108.000000, 65.000000)">
                <g id="Page-1-Copy-3" transform="translate(2.000000, 0.000000)">
                    <g id="Group-11" transform="translate(0.000000, 0.601235)">
                        <polygon id="Fill-1" className="strokeColor" stroke="currentColor" fill="currentColor" strokeLinecap="round" strokeLinejoin="round" fillRule="evenodd" points="9.70588235 12.2511765 10.8529411 12.2511765 10.8529411 0.882352941 9.70588235 0.882352941" />
                        <path d="M1.02511765,12.8707059 L0.853058824,12.8707059 C0.503647059,12.8707059 0.220411765,12.5874706 0.220411765,12.2380588 C0.220411765,11.6394533 0.220411765,11.2346886 0.220411765,11.0237647 C0.220411765,8.76723759 0.220411765,5.47082583 0.220411765,1.13452941 C0.220411765,0.785117647 0.503647059,0.501882353 0.853058824,0.501882353 L10.2262941,0.501882353 C10.5748235,0.501882353 10.8580588,0.785117647 10.8580588,1.13452941 L10.8580588,12.2380588 C10.8580588,12.5874706 10.5748235,12.8707059 10.2262941,12.8707059 L4.47776471,12.8707059" id="Stroke-3" />
                        <path d="M10.8581471,9.87291176 C10.8581471,9.87291176 10.9552059,10.8249706 9.95814706,10.8249706 L0.949323529,10.8249706 C0.949323529,10.8249706 0.2205,10.8390882 0.2205,11.4629118" id="Stroke-5" />
                        <polygon id="Stroke-9" points="3.64244118 13.8052059 2.75302941 13.4893235 1.86361765 13.8052059 1.86361765 11.9028529 3.64244118 11.9028529" />
                    </g>
                </g>
            </g>
        </g>
      </svg>
    )
  }
}